import NavBar from '../components/NavBar'
import HeroSection from '../components/ContactUs/HeroSection'
import Footer from '../components/Footer'
import ContactMap from '../components/ContactMap'

const ContactUs = () => {
	return (
		<div className="min-h-screen">
			<NavBar />
			<HeroSection />
			<ContactMap />
			<Footer />
		</div>
	)
}

export default ContactUs